export const ContentWrapper: React.FC = ({ children }) => (
  <div className="column is-full px-5 py-0 mt-3 mb-5 is-flex is-flex-direction-column">
    {children}
  </div>
)